import React from 'react';

type SectionWrapperProps = {
  children: React.ReactNode;
  className?: string;
  id?: string;
};

const SectionWrapper = ({ children, className, id }: SectionWrapperProps) => (
  <section className={`section-wrapper ${className}`} id={id}>{children}</section>
);

export default SectionWrapper;
